module.exports = __webpack_public_path__ + "img/icon_logo.a963fe77.png";